// file: src/components/footer/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import styles from './Footer.module.css';

/**
 * Footer component - Reusable footer with company links
 * Used across home, pricing, and login pages
 */
export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerSection}>
          <h4>Company</h4>
          <a href="https://www.siameseai.com/about" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
            About <ArrowUpRight size={12} />
          </a>
          <a href="https://www.siameseai.com/careers" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
            Careers <ArrowUpRight size={12} />
          </a>
        </div>
        
        <div className={styles.footerSection}>
          <h4>Resources</h4>
          <a href="https://www.siameseai.com/blog" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
            Blog <ArrowUpRight size={12} />
          </a>
          <a href="https://www.siameseai.com/contact" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
            Contact <ArrowUpRight size={12} />
          </a>
        </div>
        
        <div className={styles.footerSection}>
          <h4>Social</h4>
          <a href="https://www.linkedin.com/company/siameseai" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
            LinkedIn <ArrowUpRight size={12} />
          </a>
        </div>
      </div>
      
      <div className={styles.footerBottom}>
        <p>&copy; 2025 SiameseAI Inc.</p>
        <div className={styles.footerLinks}>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/cancel-policy">Cancellation Policy</Link>
        </div>
      </div>
    </footer>
  );
}
